import styled from "styled-components";

export const Input = styled("input")`
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-left: 30px;
  outline: none;
  width: 100%;
  min-height: calc(40px - 2px);
  height: auto;
  border: 1px solid rgb(239 240 246);
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 150ms ease-in-out;
  transition: all 150ms ease-in-out;
  border: 2px solid;
  border-radius: 10px;
  background: #ffffff inset !important;
  border-color: #f2f2f2;
  color: #4f26a2;
`;
